import { Button } from "@arco-design/web-react";
import { ChevronDown, ChevronUp } from "lucide-react";

type CrmListFilterMoreButtonProps = {
  expanded: boolean;
  onToggle: () => void;
};

/** 列表筛选「更多筛选 / 收起筛选」开关，统一放在右侧动作区。 */
export function CrmListFilterMoreButton({ expanded, onToggle }: CrmListFilterMoreButtonProps) {
  return (
    <Button
      icon={expanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      onClick={onToggle}
    >
      {expanded ? "收起筛选" : "更多筛选"}
    </Button>
  );
}
